module.exports = "//public.zight.com/packs/media/images/buttons-add-new-collection-sidebar-422b2444fc78f068bc2a787da5abc383.svg";